import { Breadcrumb, collectEndpoints, countFolders, methodOf, MethodTag, urlOf, VarText } from "./PostmanVIewHelper";

function FolderView({ node, title, tree, onSelect, isRoot }) {
  const children = isRoot ? tree : node.item;
  const endpoints = collectEndpoints(children);
  const byMethod = endpoints.reduce((m, e) => {
    m[methodOf(e)] = (m[methodOf(e)] || 0) + 1;
    return m;
  }, {});

  return (
    <div className="ad-main-inner">
      {!isRoot && <Breadcrumb path={node.path} onSelect={onSelect} tree={tree} />}
      <h1>{isRoot ? title : node.name}</h1>
      <p className="ad-lede">
        {endpoints.length} endpoint{endpoints.length === 1 ? "" : "s"}
        {isRoot && ` in ${countFolders(tree)} groups`}.{" "}
        {Object.entries(byMethod).map(([m, c], i) => (
          <span key={m} className="ad-inline-count">
            <MethodTag method={m} small /> ×{c}
            {i < Object.keys(byMethod).length - 1 ? "  " : ""}
          </span>
        ))}
      </p>

      <ul className="ad-rows">
        {children.map((c) =>
          c.kind === "folder" ? (
            <li key={c.id}>
              <button type="button" className="ad-row" onClick={() => onSelect(c.id)}>
                <span className="ad-row-folder">{c.name}</span>
                <span className="ad-row-meta">
                  {collectEndpoints(c.item).length} endpoints
                </span>
              </button>
            </li>
          ) : (
            <li key={c.id}>
              <button type="button" className="ad-row" onClick={() => onSelect(c.id)}>
                <MethodTag method={methodOf(c)} />
                <span className="ad-row-name">{c.name}</span>
                <span className="ad-row-meta ad-mono">
                  <VarText text={urlOf(c)} />
                </span>
              </button>
            </li>
          )
        )}
      </ul>
    </div>
  );
}

export default FolderView